import { adminCardsApi, cardStatusApi } from "../ENV";
import { fetchApi } from "./FetchAPI";


export const fetchCards = async (page = 1, limit = 10, search = "") => {
    try {
      const headerValue = {
        Accept: "application/json",
        "Content-type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem('access_token')}`
      };
  
      const params = { page, limit };
      if (search && search.trim() !== '') {
        params.search = search;
      }
  
      const response = await fetchApi(
        adminCardsApi,
        "GET",
        {},
        headerValue,
        params
      );
  
      if (response.status !== 200) {
        throw new Error('Failed to fetch cards');
      }
  
      return response.data;
    } catch (error) {
      throw error;
    }
  };

export const updateCardStatus = async (type, reason) => {
  try {
    const headerValue = {
      Accept: "application/json",
      "Content-type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    };

    const body = JSON.stringify({ type, reason });

    const response = await fetchApi(cardStatusApi, "POST", body, headerValue);

    if (response?.status !== 200) {
      const message = response?.data?.message || "Failed to update card status";
      throw new Error(message);
    }

    return response.data;
  } catch (error) {
    throw error;
  }
};